import { UPDropdownItem } from 'components/dropdown';
import { t } from 'i18next';
import {
  EMPLOYEES__STUDENT_FULL,
  EMPLOYEES__FLEXI_FULL,
  EMPLOYEES__EXTRA_FULL,
  EMPLOYEES__LABOURER_FULL,
  EMPLOYEES__SERVANT_FULL,
} from 'translations/constants';

export enum CoefficientsPerWorkerClass {
  STUD = 'STUD',
  FLEX = 'FLEX',
  EXT = 'EXT',
  ARB = 'ARB',
  BED = 'BED',
}

export const CoefficientsPerWorkerClassOptions = (): UPDropdownItem[] => {
  return [
    {
      label: t(EMPLOYEES__STUDENT_FULL),
      value: CoefficientsPerWorkerClass.STUD,
    },
    {
      label: t(EMPLOYEES__FLEXI_FULL),
      value: CoefficientsPerWorkerClass.FLEX,
    },
    {
      label: t(EMPLOYEES__LABOURER_FULL),
      value: CoefficientsPerWorkerClass.ARB,
    },
    {
      label: t(EMPLOYEES__EXTRA_FULL),
      value: CoefficientsPerWorkerClass.EXT,
    },
    {
      label: t(EMPLOYEES__SERVANT_FULL),
      value: CoefficientsPerWorkerClass.BED,
    },
  ];
};
